package com.evoapps.evoshift.ui.calendar

import com.evoapps.evoshift.domain.calendar.CalendarDevice
import kotlinx.browser.window

/** The web app on an iPhone or iPad (iPadOS may say Macintosh: then the web order) or on Android. */
actual fun platformCalendarDevice(): CalendarDevice {
    val agent = runCatching { window.navigator.userAgent }.getOrDefault("")
    return when {
        agent.contains("iPhone") || agent.contains("iPad") -> CalendarDevice.IOS
        agent.contains("Android") -> CalendarDevice.ANDROID
        else -> CalendarDevice.WEB
    }
}
